import React from 'react';
import styles from './AuditionsGrid.module.css';
import cardStyles from '../../components/common/AuditionCard/AuditionCard.module.css';
import AuditionCard from '../../components/common/AuditionCard/AuditionCard';
import { AdGridCard } from '../../shared/components/AdBanner';
import { useRotatingAd } from '../../shared/hooks/useAds';

/**
 * @component AuditionsGrid
 * @description 공고 카드 그리드 / 리스트 뷰
 *
 * @param {AuditionItem[]} props.items           - 공고 목록
 * @param {Set<string>}    props.savedIds       - 저장된 id 집합
 * @param {Function}       props.onCardClick    - 카드 클릭 (id) => void
 * @param {Function}       props.onSaveToggle   - 저장 토글 (id) => void
 * @param {'card'|'list'}  props.viewMode       - 뷰 모드
 * @param {number}         [props.page]         - 현재 페이지 (1페이지에만 광고 카드 노출)
 */
function AuditionsGrid({ items, savedIds, savedColorMap = {}, readIds, onCardClick, onSaveToggle, viewMode = 'card', page = 1 }) {
  const isList = viewMode === 'list';
  const { ad } = useRotatingAd('auditions-grid');
  const showAd = page === 1 && !isList && ad;

  return (
    <div className={isList ? styles.listGrid : styles.grid}>
      {items.map((item, idx) => (
        <React.Fragment key={item.id}>
          <AuditionCard
            category={item.category}
            location={item.location}
            dDay={item.dDay}
            title={item.title}
            company={item.company}
            castingDirectorName={item.castingDirectorName}
            roles={item.roles}
            status={item.status}
            isNew={item.isNew}
            isClosing={item.isClosing}
            showRoleTags={false}
            isSaved={savedIds.has(item.id)}
            savedColor={savedColorMap[item.id] || null}
            isRead={readIds ? readIds.has(item.id) : false}
            onSaveToggle={() => onSaveToggle(item.id)}
            onClick={() => onCardClick(item.id)}
            className={isList ? cardStyles.auditionCardList : ''}
          />
          {showAd && idx === 1 && <AdGridCard ad={ad} variant="audition" />}
        </React.Fragment>
      ))}
    </div>
  );
}

export default AuditionsGrid;
